/* owkar-landing.js - OWKAR Handheld Vacuum Sealer Homepage Interactivity for Shopify */

const initAll = () => {
  const init = (fnName, fn) => {
    try {
      fn();
    } catch (e) {
      console.warn(`Error initializing ${fnName}:`, e);
    }
  };
  init('initCountdown', initCountdown);
  init('initScrollRevealFallback', initScrollRevealFallback);
  init('initSpotlightGallery', initSpotlightGallery);
  init('initPdpAccordions', initPdpAccordions);
  init('initTestimonialsCarousel', initTestimonialsCarousel);
  init('initVideoModal', initVideoModal);
  init('initParallaxUnboxing', initParallaxUnboxing);
  init('initVideoParallax', initVideoParallax);
  init('initShopifyCartSync', initShopifyCartSync);
  init('initStepsCarousel', initStepsCarousel);
  init('initLandingSpotlight', initLandingSpotlight);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

/* --- Special Offer Countdown Timer --- */
function initCountdown() {
  const hoursVal = document.getElementById('hours');
  const minutesVal = document.getElementById('minutes');
  const secondsVal = document.getElementById('seconds');
  
  if (!hoursVal || !minutesVal || !secondsVal) return;

  let targetTime = localStorage.getItem('owkar_offer_end');
  if (!targetTime) {
    const endTime = Date.now() + (7 * 60 * 60 * 1000) + (42 * 60 * 1000) + (15 * 1000);
    localStorage.setItem('owkar_offer_end', endTime);
    targetTime = endTime;
  } else {
    targetTime = parseInt(targetTime, 10);
    if (targetTime < Date.now()) {
      const endTime = Date.now() + (7 * 60 * 60 * 1000) + (42 * 60 * 1000) + (15 * 1000);
      localStorage.setItem('owkar_offer_end', endTime);
      targetTime = endTime;
    }
  }

  function updateTimer() {
    const now = Date.now();
    const diff = targetTime - now;

    if (diff <= 0) {
      clearInterval(timerInterval);
      hoursVal.textContent = '00';
      minutesVal.textContent = '00';
      secondsVal.textContent = '00';
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    hoursVal.textContent = String(hours).padStart(2, '0');
    minutesVal.textContent = String(minutes).padStart(2, '0');
    secondsVal.textContent = String(seconds).padStart(2, '0');
  }

  updateTimer();
  const timerInterval = setInterval(updateTimer, 1000);
}


/* --- Scroll-Reveal Fallback (IntersectionObserver) --- */
function initScrollRevealFallback() {
  const isScrollTimelineSupported = CSS.supports('(animation-timeline: view()) and (animation-range: entry)');
  
  if (!isScrollTimelineSupported) {
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.15
    };

    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('revealed');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    const style = document.createElement('style');
    style.innerHTML = `
      .scroll-reveal {
        opacity: 0;
        transform: translateY(30px);
        transition: opacity 0.8s cubic-bezier(0.16, 1, 0.3, 1), transform 0.8s cubic-bezier(0.16, 1, 0.3, 1);
      }
      .scroll-reveal.revealed {
        opacity: 1;
        transform: translateY(0);
      }
    `;
    document.head.appendChild(style);

    document.querySelectorAll('.scroll-reveal').forEach(el => {
      revealObserver.observe(el);
    });
  }
}

/* --- Spotlight Section Gallery --- */
function initSpotlightGallery() {
  const galleries = document.querySelectorAll('.gallery-container');
  galleries.forEach(gallery => {
    if (gallery.dataset.galleryInitialized === 'true') return;
    gallery.dataset.galleryInitialized = 'true';

    const previewContainer = gallery.querySelector('.gallery-preview');
    const thumbs = gallery.querySelectorAll('.thumb-item');

    if (previewContainer) {
      previewContainer.style.transition = 'opacity 0.15s ease-in-out';
    }

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        if (thumb.classList.contains('active')) return;

        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');

        const mediaHtml = thumb.dataset.mediaHtml;
        if (previewContainer && mediaHtml) {
          previewContainer.style.opacity = 0;
          setTimeout(() => {
            previewContainer.innerHTML = mediaHtml;
            previewContainer.style.opacity = 1;
          }, 150);
        }
      });
    });
  });
}

// Re-initialize galleries on section load in theme editor
document.addEventListener('shopify:section:load', () => {
  initSpotlightGallery();
});

/* --- PDP Spotlight Accordions --- */
function initPdpAccordions() {
  const items = document.querySelectorAll('.pdp-acc-item');
  items.forEach(item => {
    const trigger = item.querySelector('.pdp-acc-trigger');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const isActive = item.classList.contains('active');
        items.forEach(i => i.classList.remove('active'));
        if (!isActive) {
          item.classList.add('active');
        }
      });
    }
  });
}

/* --- Testimonials Carousel Slider with Infinite Loop --- */
function initTestimonialsCarousel() {
  const wrapper = document.querySelector('.testimonials-carousel-wrapper');
  const track = document.querySelector('.testimonials-track-v2');
  const prevBtn = document.querySelector('.prev-v2');
  const nextBtn = document.querySelector('.next-v2');
  let cards = document.querySelectorAll('.testimonial-card-v2');

  if (!wrapper || !track || !prevBtn || !nextBtn || cards.length === 0) return;

  const originalCount = cards.length;
  const cloneCount = 4;

  const originalCardsArray = Array.from(cards);
  
  const endClones = originalCardsArray.slice(0, cloneCount).map(card => card.cloneNode(true));
  const startClones = originalCardsArray.slice(-cloneCount).map(card => card.cloneNode(true));

  track.innerHTML = '';
  startClones.forEach(c => track.appendChild(c));
  originalCardsArray.forEach(c => track.appendChild(c));
  endClones.forEach(c => track.appendChild(c));

  cards = document.querySelectorAll('.testimonial-card-v2');

  let currentIndex = cloneCount;
  let isTransitioning = false;

  function getSlideAmount() {
    if (cards.length === 0) return 0;
    const cardWidth = cards[0].offsetWidth;
    const computedStyle = window.getComputedStyle(track);
    const gap = parseInt(computedStyle.gap) || 28;
    return cardWidth + gap;
  }

  function updateCarousel(instant = false) {
    const slideAmount = getSlideAmount();
    const offset = -currentIndex * slideAmount;
    
    if (instant) {
      track.style.transition = 'none';
    } else {
      track.style.transition = 'transform 0.45s cubic-bezier(0.16, 1, 0.3, 1)';
    }

    track.style.transform = `translateX(${offset}px)`;
  }

  track.addEventListener('transitionend', () => {
    isTransitioning = false;
    
    if (currentIndex >= originalCount + cloneCount) {
      currentIndex = cloneCount;
      updateCarousel(true);
    }
    else if (currentIndex < cloneCount) {
      currentIndex = originalCount + cloneCount - 1;
      updateCarousel(true);
    }
  });

  nextBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex++;
    updateCarousel();
  });

  prevBtn.addEventListener('click', (e) => {
    e.preventDefault();
    if (isTransitioning) return;
    isTransitioning = true;
    currentIndex--;
    updateCarousel();
  });

  window.addEventListener('resize', () => {
    updateCarousel(true);
  });

  setTimeout(() => {
    updateCarousel(true);
  }, 100);
}

/* --- Video Review Modal Popup (using Event Delegation) --- */
function initVideoModal() {
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.testimonial-card-v2');
    if (!card) return;

    const videoUrl = card.getAttribute('data-video-url');
    if (!videoUrl) return;

    e.preventDefault();
    openModal(videoUrl);
  });

  function openModal(url) {
    const modal = document.createElement('div');
    modal.className = 'video-popup-modal';
    modal.innerHTML = `
      <div class="modal-backdrop"></div>
      <div class="modal-video-container">
        <button class="modal-close-btn" aria-label="Close video">✕</button>
        <video src="${url}" controls autoplay class="modal-video-player" playsinline></video>
      </div>
    `;

    const video = modal.querySelector('.modal-video-player');
    const container = modal.querySelector('.modal-video-container');
    if (video && container) {
      video.addEventListener('loadedmetadata', () => {
        if (video.videoHeight > video.videoWidth) {
          container.classList.add('portrait');
        }
      });
    }

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    const backdrop = modal.querySelector('.modal-backdrop');
    const closeBtn = modal.querySelector('.modal-close-btn');
    
    const closeModal = () => {
      modal.classList.add('closing');
      setTimeout(() => {
        modal.remove();
        document.body.style.overflow = '';
      }, 250);
    };

    backdrop.addEventListener('click', closeModal);
    closeBtn.addEventListener('click', closeModal);

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeModal();
        document.removeEventListener('keydown', handleKeyDown);
      }
    };
    document.addEventListener('keydown', handleKeyDown);
  }
}

/* --- Pinned Scroll Parallax Unboxing & Side Reveal Animation --- */
function initParallaxUnboxing() {
  const section = document.querySelector('.parallax-section');
  const sealer = document.getElementById('parallax-sealer-img');
  const box = document.getElementById('parallax-box-img');
  const cap = document.getElementById('parallax-box-cap-img');
  const leftEl = document.getElementById('side-left-el');
  const rightEl = document.getElementById('side-right-el');
  const leftCap = document.getElementById('side-left-cap');
  const rightCap = document.getElementById('side-right-cap');
  const arrowImg = document.getElementById('unboxing-arrow-img');
  const arrowCap = document.getElementById('unboxing-arrow-caption');
  const arrowImgRight = document.getElementById('unboxing-arrow-img-right');
  const arrowCapRight = document.getElementById('unboxing-arrow-caption-right');
 
  if (!section || !sealer || !box || !cap || !leftEl || !rightEl || !leftCap || !rightCap || !arrowImg || !arrowCap || !arrowImgRight || !arrowCapRight) return;

  function handleScroll() {
    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const totalStickyScroll = rect.height - viewportHeight;

    if (totalStickyScroll <= 0) return;

    if (rect.top <= 0 && rect.bottom >= viewportHeight) {
      const progress = Math.abs(rect.top) / totalStickyScroll;
      
      let sealerY, sealerScale, boxY, boxOpacity;
      let leftOpacity = 0, leftTranslateX = -120;
      let rightOpacity = 0, rightTranslateX = 120;
      let capOpacity = 0;

      if (progress <= 0.40) {
        const p1 = progress / 0.40;
        const startY = 220;
        const endY = -90;
        sealerY = startY - (p1 * (startY - endY));
        sealerScale = 1.0;
        boxY = 0;
        boxOpacity = 1.0;
      } 
      else if (progress <= 0.70) {
        const p2 = (progress - 0.40) / 0.30;
        sealerY = -90;
        sealerScale = 1.0 + (p2 * 0.35);
        boxY = p2 * 350;
        boxOpacity = 1.0 - p2;
      } 
      else {
        const p3 = (progress - 0.70) / 0.30;
        sealerY = -90;
        sealerScale = 1.35;
        boxY = 350;
        boxOpacity = 0.0;
        leftOpacity = p3;
        leftTranslateX = -120 + (p3 * 120);
        rightOpacity = p3;
        rightTranslateX = 120 - (p3 * 120);

        if (progress > 0.85) {
          capOpacity = (progress - 0.85) / 0.15;
        }
      }

      sealer.style.transform = `translateY(${sealerY}px) scale(${sealerScale})`;
      box.style.transform = `translateY(${boxY}px)`;
      box.style.opacity = boxOpacity;
      cap.style.transform = `translateY(${boxY}px)`;
      cap.style.opacity = boxOpacity;

      leftEl.style.opacity = leftOpacity;
      leftEl.style.transform = `translateX(${leftTranslateX}px)`;
      leftCap.style.opacity = capOpacity;
      arrowImg.style.opacity = leftOpacity;
      arrowImg.style.transform = `translateX(${leftTranslateX}px) rotate(45deg)`;
      arrowCap.style.opacity = leftOpacity;
      arrowCap.style.transform = `translateX(${leftTranslateX}px)`;
 
      rightEl.style.opacity = rightOpacity;
      rightEl.style.transform = `translateX(${rightTranslateX}px)`;
      rightCap.style.opacity = capOpacity;
      arrowImgRight.style.opacity = rightOpacity;
      arrowImgRight.style.transform = `translateX(${rightTranslateX}px) rotate(-45deg)`;
      arrowCapRight.style.opacity = rightOpacity;
      arrowCapRight.style.transform = `translateX(${rightTranslateX}px)`;
    } 
    else if (rect.top > 0) {
      sealer.style.transform = 'translateY(220px) scale(1)';
      box.style.transform = 'translateY(0)';
      box.style.opacity = '1';
      cap.style.transform = 'translateY(0)';
      cap.style.opacity = '1';

      leftEl.style.opacity = '0';
      leftEl.style.transform = 'translateX(-120px)';
      leftCap.style.opacity = '0';
      arrowImg.style.opacity = '0';
      arrowImg.style.transform = 'translateX(-120px) rotate(45deg)';
      arrowCap.style.opacity = '0';
      arrowCap.style.transform = 'translateX(-120px)';

      rightEl.style.opacity = '0';
      rightEl.style.transform = 'translateX(120px)';
      rightCap.style.opacity = '0';
      arrowImgRight.style.opacity = '0';
      arrowImgRight.style.transform = 'translateX(120px) rotate(-45deg)';
      arrowCapRight.style.opacity = '0';
      arrowCapRight.style.transform = 'translateX(120px)';
    } 
    else if (rect.bottom < viewportHeight) {
      sealer.style.transform = 'translateY(-90px) scale(1.35)';
      box.style.transform = 'translateY(350px)';
      box.style.opacity = '0';
      cap.style.transform = 'translateY(350px)';
      cap.style.opacity = '0';

      leftEl.style.opacity = '1';
      leftEl.style.transform = 'translateX(0)';
      leftCap.style.opacity = '1';
      arrowImg.style.opacity = '1';
      arrowImg.style.transform = 'translateX(0) rotate(45deg)';
      arrowCap.style.opacity = '1';
      arrowCap.style.transform = 'translateX(0)';

      rightEl.style.opacity = '1';
      rightEl.style.transform = 'translateX(0)';
      rightCap.style.opacity = '1';
      arrowImgRight.style.opacity = '1';
      arrowImgRight.style.transform = 'translateX(0) rotate(-45deg)';
      arrowCapRight.style.opacity = '1';
      arrowCapRight.style.transform = 'translateX(0)';
    }
  }

  window.addEventListener('scroll', handleScroll);
  window.addEventListener('resize', handleScroll);
  setTimeout(handleScroll, 100);
}

/* --- Full-Width Video Player & Fast Playback --- */
function initVideoParallax() {
  const videoSections = document.querySelectorAll('.parallax-video-section');
  if (!videoSections.length) return;

  videoSections.forEach(videoSection => {
    const video = videoSection.querySelector('video');
    if (!video) return;

    // Explicitly enforce muted autoplay requirements for immediate browser decoding
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    // Reset any transform
    video.style.transform = 'none';

    // Attempt immediate playback
    const startPlay = () => {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Autoplay retry on user scroll/touch
          const resumeOnInteract = () => {
            video.play().catch(() => {});
            window.removeEventListener('touchstart', resumeOnInteract);
            window.removeEventListener('scroll', resumeOnInteract);
          };
          window.addEventListener('touchstart', resumeOnInteract, { passive: true, once: true });
          window.addEventListener('scroll', resumeOnInteract, { passive: true, once: true });
        });
      }
    };

    startPlay();

    // Intersection observer for fast pre-buffering and viewport management
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (video.paused) {
              video.play().catch(() => {});
            }
          }
        });
      }, { rootMargin: '600px 0px' });
      observer.observe(videoSection);
    }
  });
}

/* --- Shopify Cart Sync and Checkout AJAX Actions --- */
function initShopifyCartSync() {
  const cartBubble = document.getElementById('cart-bubble');

  function updateCartBubble() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (cartBubble) {
          cartBubble.textContent = cart.item_count;
          cartBubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
        }
      })
      .catch(err => console.error('Error fetching cart state:', err));
  }

  updateCartBubble();

  document.addEventListener('cart:update', () => {
    updateCartBubble();
  });

  const cartIcon = document.getElementById('cart-icon-btn');
  if (cartIcon) {
    cartIcon.addEventListener('click', (e) => {
      e.preventDefault();
      const nativeDrawer = document.querySelector('cart-drawer-component');
      if (nativeDrawer && typeof nativeDrawer.open === 'function') {
        nativeDrawer.open();
      }
    });
  }

  window.addShopifyItemToCart = function(variantId, qty = 1, options = {}) {
    if (!variantId) {
      console.warn('Cannot add item: variant ID is missing');
      return;
    }

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionsToRender = [];
    cartItemsComponents.forEach((item) => {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToRender.push(item.dataset.sectionId);
      }
    });

    const payload = {
      items: [{
        id: parseInt(variantId, 10),
        quantity: parseInt(qty, 10)
      }]
    };

    if (options.upsells && options.upsells.length > 0) {
      options.upsells.forEach(id => {
        payload.items.push({
          id: parseInt(id, 10),
          quantity: 1
        });
      });
    }

    if (sectionsToRender.length > 0) {
      payload.sections = sectionsToRender.join(',');
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    })
    .then(res => {
      if (!res.ok) {
        return res.json().then(err => {
          throw new Error(err.description || err.message || 'Failed to add items to cart');
        });
      }
      return res.json();
    })
    .then(data => {
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: 'custom-landing-add-to-cart',
          data: {
            sections: data.sections || {}
          }
        }
      }));

      document.dispatchEvent(new CustomEvent('cart:add', {
        bubbles: true,
        detail: {
          resource: data,
          sourceId: 'custom-landing-add-to-cart',
          data: {
            sections: data.sections || {}
          }
        }
      }));

      const nativeDrawer = document.querySelector('cart-drawer-component');
      if (nativeDrawer && typeof nativeDrawer.open === 'function') {
        nativeDrawer.open();
      } else {
        window.location.reload();
      }
    })
    .catch(err => {
      console.error('Failed to add items to Shopify cart:', err);
      alert('Error adding items: ' + err.message);
    });
  };

  document.addEventListener('click', (e) => {
    const cartTrigger = e.target.closest('.add-to-cart-trigger');
    if (cartTrigger) {
      e.preventDefault();
      const variantId = cartTrigger.dataset.variantId;
      if (variantId) {
        window.addShopifyItemToCart(variantId, 1);
      } else {
        console.warn('Add to cart button missing data-variant-id attribute');
      }
    }
  });
}

/* --- Spotlight Section Initialization --- */
function initLandingSpotlight() {
  const spotlightSections = document.querySelectorAll('.spotlight-section');
  spotlightSections.forEach(spotlightSection => {
    if (spotlightSection.dataset.spotlightInitialized === 'true') return;
    spotlightSection.dataset.spotlightInitialized = 'true';

    const mainQtySelector = spotlightSection.querySelector('.purchase-controls .quantity-selector');
    const qtyInput = mainQtySelector ? mainQtySelector.querySelector('.qty-input') : null;
    const minusBtn = mainQtySelector ? mainQtySelector.querySelector('.minus-btn') : null;
    const plusBtn = mainQtySelector ? mainQtySelector.querySelector('.plus-btn') : null;
    const addBtn = spotlightSection.querySelector('.spotlight-add-to-cart');
    const buyBtn = spotlightSection.querySelector('.spotlight-buy-now');

    if (qtyInput && minusBtn && plusBtn) {
      minusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(qtyInput.value, 10) || 1;
        if (val > 1) {
          qtyInput.value = val - 1;
        }
      });

      plusBtn.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Toggle active class on option-card when checkbox checked
    const optionCards = spotlightSection.querySelectorAll('.option-card');
    optionCards.forEach(card => {
      const checkbox = card.querySelector('.option-checkbox');
      if (checkbox) {
        checkbox.addEventListener('change', () => {
          if (checkbox.checked) {
            card.classList.add('active');
          } else {
            card.classList.remove('active');
          }
        });
      }
    });

    const triggerSpotlightAction = (isBuyNow = false) => {
      const mainVariantId = addBtn ? addBtn.dataset.variantId : (buyBtn ? buyBtn.dataset.variantId : null);
      const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      
      const upsellIds = [];
      const checkedUpsells = spotlightSection.querySelectorAll('.option-card input[type="checkbox"]:checked');
      checkedUpsells.forEach(cb => {
        if (cb.dataset.variantId) {
          upsellIds.push(cb.dataset.variantId);
        }
      });

      if (mainVariantId) {
        if (isBuyNow) {
          const formData = {
            items: [{
              id: parseInt(mainVariantId, 10),
              quantity: qty
            }]
          };
          if (upsellIds.length > 0) {
            upsellIds.forEach(id => {
              formData.items.push({
                id: parseInt(id, 10),
                quantity: 1
              });
            });
          }
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(() => {
            window.location.href = '/checkout';
          })
          .catch(err => {
            console.error('Buy Now redirection failed:', err);
            window.location.href = '/checkout';
          });
        } else {
          window.addShopifyItemToCart(mainVariantId, qty, { upsells: upsellIds });
        }
      } else {
        console.warn('Spotlight button missing data-variant-id attribute');
      }
    };

    if (addBtn) {
      addBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;
        triggerSpotlightAction(false);
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (buyBtn.disabled || buyBtn.getAttribute('aria-disabled') === 'true') return;
        triggerSpotlightAction(true);
      });
    }
  });
}

/* --- Steps How-It-Works Carousel with Autoplay & Dots --- */
function initStepsCarousel() {
  const section = document.querySelector('.how-it-works');
  if (!section) return;

  const track = document.getElementById('steps-track');
  const dotsContainer = document.getElementById('steps-dots');
  if (!track || !dotsContainer) return;

  const cards = track.querySelectorAll('.step-card');
  if (cards.length === 0) return;

  const autoplaySetting = section.getAttribute('data-autoplay') === 'true';
  const autoplaySpeed = parseInt(section.getAttribute('data-speed'), 10) || 5000;

  let currentIndex = 0;
  let autoplayTimer = null;

  function getVisibleCardsCount() {
    const width = window.innerWidth;
    if (width >= 1025) return 4;
    if (width >= 769) return 3;
    if (width >= 481) return 2;
    return 1;
  }

  function getCardWidth() {
    return cards[0].offsetWidth;
  }

  function getGap() {
    return 30;
  }

  function getMaxIndex() {
    const visibleCount = getVisibleCardsCount();
    return Math.max(0, cards.length - visibleCount);
  }

  function generateDots() {
    dotsContainer.innerHTML = '';
    const maxIndex = getMaxIndex();
    
    if (maxIndex === 0) {
      dotsContainer.style.display = 'none';
      return;
    }
    
    dotsContainer.style.display = 'flex';

    for (let i = 0; i <= maxIndex; i++) {
      const dot = document.createElement('button');
      dot.classList.add('steps-dot');
      if (i === currentIndex) {
        dot.classList.add('active');
      }
      dot.setAttribute('aria-label', `Go to step slide ${i + 1}`);
      
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        currentIndex = i;
        updateCarousel();
        resetAutoplay();
      });

      dotsContainer.appendChild(dot);
    }
  }

  function updateCarousel() {
    const maxIndex = getMaxIndex();
    if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    }
    if (currentIndex < 0) {
      currentIndex = 0;
    }

    const cardWidth = getCardWidth();
    const gap = getGap();
    const slideAmount = cardWidth + gap;
    const offset = -currentIndex * slideAmount;

    track.style.transform = `translateX(${offset}px)`;

    const dots = dotsContainer.querySelectorAll('.steps-dot');
    dots.forEach((dot, index) => {
      if (index === currentIndex) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });
  }

  function startAutoplay() {
    if (!autoplaySetting) return;
    
    autoplayTimer = setInterval(() => {
      const maxIndex = getMaxIndex();
      if (maxIndex === 0) return;

      if (currentIndex >= maxIndex) {
        currentIndex = 0;
      } else {
        currentIndex++;
      }
      updateCarousel();
    }, autoplaySpeed);
  }

  function resetAutoplay() {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      startAutoplay();
    }
  }

  window.addEventListener('resize', () => {
    generateDots();
    updateCarousel();
  });

  generateDots();
  setTimeout(updateCarousel, 300);
  startAutoplay();
}

document.addEventListener('shopify:section:load', () => {
  initLandingSpotlight();
});
